/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jobticketkenntnis2Inputs */



/**

* @param {_Field_Jobticketkenntnis2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jobticketkenntnis2 = /** @type {((inputs?: _Field_Jobticketkenntnis2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jobticketkenntnis2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jobticket Kenntnis")
});
export { _field_jobticketkenntnis2 as "_field_jobTicketKenntnis" }